<div class="fit-wrapper">
  <div *ngFor="let item of fitAndProperQuestionnaire; let index = index" class="fit-item">
    <div class="fit-question">
      {{ index + 1 }}. {{item.questionText}}
    </div>
    <div class="fit-answer">
      <span *ngIf="item.isYes">{{item.explanation}}</span>
      <span *ngIf="!item.isYes">No</span>
    </div>
  </div>
</div>
